<template>
  <div class="conventional-dashboard-shell">
    <div class="dash-page-wrapper conventional-dash-layout">
      <DashboardList ref="reloadDashboards" @selected-dashboard="handleselectedDashboard" />
      <div class="dash-main-column">
        <DashboardView :selectedDashboard="selectedDashboard" @dashboard-delete="reloadDashboards"/>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardList from '@/components/layout/DashboardNew/DashboardList.vue';
import DashboardView from '@/components/layout/DashboardNew/DashboardView.vue';
export default {
  components: { DashboardList, DashboardView },
  name: "List",
  data() {
    return {
      selectedDashboard: {},
    }
  },
  methods: {
    handleselectedDashboard (dashboard) {
      this.selectedDashboard = dashboard
    },
    reloadDashboards() {
      this.selectedDashboard = {};
      this.$refs.reloadDashboards.getSavedDashboards();
    },
  },
};
</script>
